/**
 * @generated SignedSource<<096ebcab93a3008db9c9061810526098>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AIStudioTaskState = "COMPLETED" | "ERROR" | "NO_CREDITS" | "PROCESSING" | "WAITING";
export type sideGeneratorBulkStatusQuery$variables = {
  taskIds: ReadonlyArray<number>;
};
export type sideGeneratorBulkStatusQuery$data = {
  readonly sideGeneratorBulkStatus: {
    readonly completed: number;
    readonly failed: number;
    readonly items: ReadonlyArray<{
      readonly errorMessage: string | null;
      readonly resultUrl: string | null;
      readonly state: AIStudioTaskState;
      readonly taskId: number;
    }>;
    readonly processing: number;
    readonly total: number;
    readonly waiting: number;
  } | null;
};
export type sideGeneratorBulkStatusQuery = {
  response: sideGeneratorBulkStatusQuery$data;
  variables: sideGeneratorBulkStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskIds"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "taskIds",
        "variableName": "taskIds"
      }
    ],
    "concreteType": "SideGeneratorBulkStatus",
    "kind": "LinkedField",
    "name": "sideGeneratorBulkStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "total",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "waiting",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "processing",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "completed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "failed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SideGeneratorBulkStatusItem",
        "kind": "LinkedField",
        "name": "items",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taskId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resultUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errorMessage",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sideGeneratorBulkStatusQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "sideGeneratorBulkStatusQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "5dd7f3ac706d4170cbc5a0ff9cf5835e",
    "id": null,
    "metadata": {},
    "name": "sideGeneratorBulkStatusQuery",
    "operationKind": "query",
    "text": "query sideGeneratorBulkStatusQuery(\n  $taskIds: [Long!]!\n) {\n  sideGeneratorBulkStatus(taskIds: $taskIds) {\n    total\n    waiting\n    processing\n    completed\n    failed\n    items {\n      taskId\n      state\n      resultUrl\n      errorMessage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e618d83efadd0fabf51e699e593ba0cb";

export default node;
